<template>
  <footer class="db center w-100 mw8-ns ph3 pv5 bn navy">
    <a href="mailto:hello@cryptogigs.co" class="link b f3 f2-ns dim lh-solid navy">hello@cryptogigs.co</a>
    <p class="f6 db b ttu lh-solid o-80">&copy; {{ currentYear }} cryptogigs.co inc</p>
    <div class="mt5">
      <router-link :to="{ name: 'about' }" title="About" class="f6 dib pr2 mid-gray dim">
        About
      </router-link>
      <router-link :to="{ name: 'terms' }" title="Terms" class="f6 dib ph2 mid-gray dim">
        Terms
      </router-link>
      <router-link :to="{ name: 'privacy' }" title="Privacy" class="f6 dib pl2 mid-gray dim">
        Privacy
      </router-link>
    </div>
  </footer>
</template>

<script>
import Auth from '@/auth'
export default {
  name: 'Footer',
  data () {
    return {
      auth: this.$store.state.auth,
      currentYear: new Date().getFullYear()
    }
  },
  methods: {
    logout () {
      Auth.logout()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/AppFooter.vue